module.exports = __webpack_public_path__ + "img/charger-icon.60ad5045.png";